import React, { ReactElement } from "react";
import "./Toggle.css";

interface ToggleProps {
  onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
  checked: boolean;
  disabled?: boolean;
  onKeyPress: (ev: React.KeyboardEvent<HTMLSpanElement>) => void;
  name: string;
  value?: string;
  id: string;
}

const Toggle: React.FC<ToggleProps> = ({
  onClick,
  checked = false,
  disabled = false,
  onKeyPress,
  name,
  value,
  id,
  ...rest
}): ReactElement => {
  return (
    <div className={`Toggle ${disabled ? "disabled" : ""}`}>
      <span className={`outerBox ${checked ? "" : "un"}checkedOuterBox`} onClick={onClick}>
        <span
          id={id}
          role="switch"
          aria-checked={checked}
          className={`handle ${checked ? "" : "un"}checkedHandle`}
          onClick={onClick}
          onKeyPress={onKeyPress}
          tabIndex={disabled ? -1 : 0}
          aria-label={name}
          {...rest}
        >
          {value}
        </span>
        <input
          type="checkbox"
          name={name}
          className="checkbox"
          onClick={onClick}
          onKeyPress={onKeyPress}
        />
      </span>
    </div>
  );
};

export default Toggle;
